(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-section"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Prevent double initialisation
  if (window.__t4sBirdScrollInit) return;
  window.__t4sBirdScrollInit = true;

  var SELECTOR = '.t4s-custom-section .t4s-img-child img, .t4s-custom-section .t4s-lookbook-img img';

  // Image centre reaches this point of the screen height (0 = top, 1 = bottom) => bird is fully in place.
  // Smaller value = longer scroll distance for the animation, larger value = faster.
  var END_POINT = 0.7;

  // Smoothness: lower = smoother/slower, higher = snappier (0.05 - 0.3)
  var SMOOTH = 0.14;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var states = new WeakMap();
  var running = false;

  function ease(t) {
    return 1 - Math.pow(1 - t, 3);
  }

  function frame() {
    var imgs = document.querySelectorAll(SELECTOR);
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var moving = false;

    imgs.forEach(function (img) {
      var rect = img.getBoundingClientRect();

      // Skip hidden images (for example the desktop image on mobile and the mobile image on desktop)
      if (!rect.width || !rect.height) return;

      var st = states.get(img);
      if (!st) {
        st = { x: 0, init: false };
        states.set(img, st);
        img.classList.add('t4s-bird-animate');
        if (img.parentElement) {
          var wrap = img.closest('.t4s-img-child') || img.parentElement;
          wrap.classList.add('t4s-bird-wrap');
        }
      }

      // Natural (untransformed) left edge of the image
      var baseLeft = rect.left - st.x;

      // How far left the image must move to be fully outside the screen
      var offset = -(baseLeft + rect.width + 20);

      // Scroll progress: 0 = image just entering at the bottom of the screen, 1 = in its final place
      var centerY = rect.top + rect.height / 2;
      var p = (vh - centerY) / (vh * (1 - END_POINT));
      p = Math.min(1, Math.max(0, p));

      var target = reduceMotion ? 0 : offset * (1 - ease(p));

      if (!st.init) {
        // First run: place directly without animating
        st.x = target;
        st.init = true;
      } else {
        var diff = target - st.x;
        if (Math.abs(diff) > 0.3) {
          st.x += diff * SMOOTH;
          moving = true;
        } else {
          st.x = target;
        }
      }

      img.style.transform = 'translate3d(' + st.x.toFixed(2) + 'px, 0, 0)';
    });

    if (moving) {
      requestAnimationFrame(frame);
    } else {
      running = false;
    }
  }

  function request() {
    if (!running) {
      running = true;
      requestAnimationFrame(frame);
    }
  }

  window.addEventListener('scroll', request, { passive: true });
  window.addEventListener('resize', request);
  window.addEventListener('load', request);
  window.addEventListener('orientationchange', request);
  document.addEventListener('shopify:section:load', request);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', request);
  } else {
    request();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
